import { buildRoute, noEnvRoutes } from "@/assets/routes/routes";
import api from "../api";
import { isAxiosError } from "axios";

export const getInspectionId = async ({ id }: { id: number }) => {
  try {
    const url = buildRoute(noEnvRoutes.getInspectionById, { id });
    const result = await api.get(url);
    if (result && result.status === 200) {
      return result.data;
    } else {
      throw new Error("NOT_FOUND");
    }
  } catch (error) {
    if (error instanceof Error && error.message === "NOT_FOUND") {
      throw new Error("NOT_FOUND_INSPECTION");
    } else if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getInspectionPDF = async ({ id }: { id: number }) => {
  try {
    const url = buildRoute(noEnvRoutes.getInspectionPDF, { id });
    const { data } = await api.get(url);
    const documentUrl = data?.document_url;
    if (!documentUrl) {
      throw new Error("DOCUMENT_URL_NOT_FOUND");
    }

    const documentResponse = await fetch(documentUrl);
    if (!documentResponse.ok) {
      throw new Error("DOCUMENT_URL_NOT_FOUND");
    }

    return await documentResponse.blob();
  } catch (error) {
    if (error instanceof Error && error.message === "DOCUMENT_URL_NOT_FOUND") {
      throw error;
    } else if (isAxiosError(error) && error.response) {
      throw new Error(error.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const deleteInspectionId = async ({ id }: { id: number }) => {
  try {
    const url = buildRoute(noEnvRoutes.deleteInspectionId, { id });
    const result = await api.delete(url);
    if ((result && result.status === 200) || result.status === 204) {
      return "OK";
    } else {
      throw new Error("NOT_FOUND");
    }
  } catch (error) {
    if (error instanceof Error && error.message === "NOT_FOUND") {
      throw new Error("NOT_FOUND_INSPECTION");
    } else if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};
